var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1080,
    viewBox: "0 0 862 1080",
    width: 862,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-818.695 864.099C-643.444 1025.8 -452.915 1104.41 -222.013 1077.79C8.87952 1051.17 185.91 905.9 339.905 730.759C493.94 555.573 562.534 422.403 548.634 201.145C534.741 -20.0121 443.569 -235.407 270.358 -379.406C97.1491 -523.404 -87.3514 -549.287 -318.227 -519.567C-549.206 -489.842 -732.35 -387.858 -888.381 -230.331C-1044.34 -72.8863 -1112.89 50.47 -1099.04 268.487C-1085.19 486.601 -993.981 702.369 -818.695 864.099Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupVector2);
export default __webpack_public_path__ + "static/media/signup_vector_2.916cbe51fe3d945e4e6f1b82950638a2.svg";
export { ForwardRef as ReactComponent };